import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EntityId } from '@shared/core/types';

interface User {
  id?: EntityId;
  name?: string;
  surname?: string;
}

@Component({
  selector: 'crm-user-info',
  templateUrl: './user-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  @Input() user: User | null;
  @Input() ifEmpty = '';
}
